/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiSearchIndex,
    ApiSearchIndexFromJSON,
    ApiSearchIndexToJSON,
} from '../models';

export interface FindSearchIndexesRequest {
    source: FindSearchIndexesSourceEnum;
}

export interface UpdateSanctionListRequest {
    source: UpdateSanctionListSourceEnum;
}

/**
 * 
 */
export class SanctionListsApi extends runtime.BaseAPI {

    /**
     * Find search indexes of a sanction list provider
     */
    async findSearchIndexesRaw(requestParameters: FindSearchIndexesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiSearchIndex>>> {
        if (requestParameters.source === null || requestParameters.source === undefined) {
            throw new runtime.RequiredError('source','Required parameter requestParameters.source was null or undefined when calling findSearchIndexes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/lists/{source}`.replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiSearchIndexFromJSON));
    }

    /**
     * Find search indexes of a sanction list provider
     */
    async findSearchIndexes(requestParameters: FindSearchIndexesRequest, initOverrides?: RequestInit): Promise<Array<ApiSearchIndex>> {
        const response = await this.findSearchIndexesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates sanctions list
     */
    async updateSanctionListRaw(requestParameters: UpdateSanctionListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.source === null || requestParameters.source === undefined) {
            throw new runtime.RequiredError('source','Required parameter requestParameters.source was null or undefined when calling updateSanctionList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/lists/{source}`.replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates sanctions list
     */
    async updateSanctionList(requestParameters: UpdateSanctionListRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateSanctionListRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum FindSearchIndexesSourceEnum {
    DOWJONES = 'DOWJONES'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateSanctionListSourceEnum {
    DOWJONES = 'DOWJONES'
}
